"use client";

import React from "react";
import Leadership from "./Leadership";

const AboutUsPage = () => {
  return (
    <>
      <section className="about-us-page global-inner-page-pm">
        <div className="container">
          <div className="text-center">
            <h1 className="inner-first-heading mb-3">About Us</h1>
            <div
              className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
              style={{ background: "#f26624" }}
            ></div>
            {/* <p
              className="mx-auto text-muted text-left mb-0"
            >
              The company is managed by seasoned professionals possessing
              extensive experience and expertise. Their deep understanding of
              the hospitality industry, combined with hands-on experience, has
              driven the organization to the forefront of the sector. To address
              the expanding demands of the hospitality market, they have
              established a comprehensive network of Sales and Marketing offices
              nationwide. Additionally, the organization has implemented a
              strong Operations and IT infrastructure to support its growth and
              service excellence.
            </p> */}
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              {/* <h3 className="inner-third-heading mb-3">
                We operate hotels and clubs across the country and overseas.
              </h3>
              <p className="text-justify text-muted">
                With a presence spanning the country and currently operating
                over 32 hotels, the company has entered into a binding agreement
                with Louvre Hotels Group to manage and operate Kyriad Hotels as
                a business. This agreement includes the development, management,
                and rights to the brands and trademarks of Kyriad Hotels and its
                related brands. The company holds exclusive management and
                development rights for all Kyriad Hotels being developed across
                India, Nepal, Bhutan, Maldives, Mauritius, Pakistan, and Sri
                Lanka. To date, approximately 10 properties have been signed
                under the Kyriad brand in India. Additionally, the company has
                recently launched two new hotel brands, Mastiff and Esperanto.
              </p> */}
              <p className="text-justify text-muted">
                Orange Tiger Hospitality Pvt. Ltd. (OTHPL) is a Mumbai-based
                hospitality management company founded in 2017, specializing in
                hotel and club operations across India and internationally.
              </p>
              <p className="text-justify text-muted">
                The company is led by seasoned professionals with deep expertise and
                extensive hospitality experience. Their industry insight and
                practical know-how have positioned the organization as a sector
                leader. To meet growing market demands, they’ve built a
                nationwide network of Sales and Marketing offices, supported by
                robust Operations and IT infrastructure for sustained growth and
                service excellence.
              </p>
              <p className="text-justify text-muted">
                Operating over 60 hotels across the country,
                the company has a binding agreement with Louvre Hotels Group to
                manage Kyriad Hotels as a business, including development rights
                and trademarks for Kyriad and related brands. It holds exclusive
                management and development rights for all Kyriad properties in
                India, Nepal, Bhutan, Maldives, Mauritius, Pakistan, and Sri
                Lanka.
              </p>
            </div>
            {/* <div className="col-md-6">
              <div className="about-us-page-image">
                <Image
                  src="/about-image.webp"
                  alt="about orange tiger"
                  height={270}
                  width={700}
                />
              </div>
            </div> */}
          </div>

          <div className="about-mission-vision mt-3">
            <div className="vision-mission-container">
              <div className="vision-section">
                <h2>Vision</h2>
                <p>
                  Exceeding guest expectations at all our hotels, drive desired
                  profitability for owners and provide a promising career to our
                  colleagues.
                </p>
              </div>
              <div className="mission-section">
                <h2>Mission</h2>
                <p>
                  To be recognized as the preferred hospitality company for all
                  the stakeholders.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-center inner-first-heading mb-3 mt-5 fw-semibold">
              Our Leadership Team
            </h2>
            <div
              className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
              style={{ background: "#f26624" }}
            >
              {" "}
            </div>
          </div>

          <Leadership />
        </div>
      </section>

      <style jsx>
        {`
          .vision-mission-container {
            display: flex;
            gap: 32px;
            // justify-content: space-between;
            background-color: #f04e02; /* Yellow background */
            padding: 40px;
            border-radius: 8px;
            color: #fff;
          }

          .vision-section,
          .mission-section {
            width: 45%;
          }

          .vision-mission-container h2 {
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            margin-bottom: 10px;
          }

          .vision-mission-container p {
            color: #fff;
            line-height: 1.6;
          }

          .vision-section {
            border-right: 2px solid #ccc;
            padding-right: 20px;
          }

          .vision-section h2,
          .mission-section h2 {
            color: #fff;
          }

          .vision-mission-container h2 {
            text-align: left;
          }

          @media (max-width: 767px) {
            .vision-section,
            .mission-section {
              width: 100%;
            }
            .vision-section {
              border-right: none;
              padding-right: 0px;
            }

            .vision-mission-container {
              display: block;

              padding: 20px;
            }
          }
        `}
      </style>
    </>
  );
};

export default AboutUsPage;
